import { HorizontalStepper } from "@dune/ui";
import { useQueryState } from "nuqs";
import { PricingOptionsProvider } from "../offers/contexts/PricingOptionsContext";
import { ReceptionAnalysisControls } from "./steps/ReceptionAnalysisControls";
import { ReceptionAnalysisReserves } from "./steps/ReceptionAnalysisReserves";
import { ReceptionAnalysisValidation } from "./steps/ReceptionAnalysisValidation";

const STEP_CONTROLS = 1;
const STEP_RESERVES = 2;
const STEP_VALIDATION = 3;

const RECEPTION_ANALYSIS_STEPS = [
	{ step: STEP_CONTROLS, title: "Contrôles" },
	{ step: STEP_RESERVES, title: "Réserves" },
	{ step: STEP_VALIDATION, title: "Validation" },
];

export const ReceptionAnalysisContent = () => {
	const [currentStepIndex, setCurrentStepIndex] = useQueryState("step", {
		defaultValue: STEP_CONTROLS,
		parse: (value) => {
			const parsed = Number(value);
			if (Number.isNaN(parsed) || parsed < 1 || parsed > 3) {
				return STEP_CONTROLS;
			}
			return parsed;
		},
		serialize: (value) => String(value),
	});

	return (
		<PricingOptionsProvider>
			<div className="flex flex-col gap-4">
				<HorizontalStepper
					steps={RECEPTION_ANALYSIS_STEPS}
					currentStepIndex={currentStepIndex}
					setCurrentStepIndex={setCurrentStepIndex}
					parentPaddingOffsetPx={24}
				/>
				{currentStepIndex === STEP_CONTROLS && (
					<ReceptionAnalysisControls
						onNext={() => setCurrentStepIndex(STEP_RESERVES)}
					/>
				)}
				{currentStepIndex === STEP_RESERVES && (
					<ReceptionAnalysisReserves
						onPrev={() => setCurrentStepIndex(STEP_CONTROLS)}
						onNext={() => setCurrentStepIndex(STEP_VALIDATION)}
					/>
				)}
				{currentStepIndex === STEP_VALIDATION && (
					<ReceptionAnalysisValidation
						onPrev={() => setCurrentStepIndex(STEP_RESERVES)}
					/>
				)}
			</div>
		</PricingOptionsProvider>
	);
};

export default ReceptionAnalysisContent;
